import React from 'react'
import { CommentAnchorType } from '@marketing-milk/interfaces'
import { radius, SurfacePalette, type } from '../../tokens'
import { SectionHead } from '../../components/SectionHead'
import { CommentIndicator } from '../../components/CommentIndicator'
import { useUnresolvedCountLookup } from '../UnresolvedCommentsContext'
import { sectionNumberFor, SectionKey } from '../sections'

interface Props {
  palette: SurfacePalette
  sectionKey: SectionKey
  title: string
  muted?: boolean
  commentAnchor?: { type: CommentAnchorType; id: string; label?: string }
  children?: React.ReactNode
}

export const SectionCard = ({
  palette,
  sectionKey,
  title,
  muted,
  commentAnchor,
  children,
}: Props) => {
  const countFor = useUnresolvedCountLookup()
  return (
    <section
      id={sectionKey}
      data-section-key={sectionKey}
      data-comment-anchor-type={commentAnchor?.type}
      data-comment-anchor-id={commentAnchor?.id}
      data-comment-label={commentAnchor?.label}
      style={{
        padding: 28,
        borderRadius: radius.lg,
        border: `1px solid ${palette.hairline}`,
        background: muted ? palette.bg : palette.surface,
        scrollMarginTop: 16,
        fontFamily: type.family.sans,
        color: palette.text,
      }}
    >
      <SectionHead
        palette={palette}
        number={sectionNumberFor(sectionKey)}
        title={title}
        right={
          commentAnchor ? (
            <CommentIndicator
              palette={palette}
              label={title}
              unresolvedCount={countFor(commentAnchor.type, commentAnchor.id)}
            />
          ) : undefined
        }
      />
      {children}
    </section>
  )
}
